module.exports = __webpack_public_path__ + "static/media/oven.3a833806.svg";